import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/card.module.scss'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'

type Props = {
  label: string
  children?: ReactNode
}

const OrderCardBodySummaryLabel: FC<Props> = (props) => {
  const { children, label } = props
  return (
    <FlexRow justifyContent={'start'}>
      <div className={styles.order__body__summary__label}>
        <span>{label}</span>
        <span>：</span>
      </div>
      <Spacer size={4} />
      {children}
    </FlexRow>
  )
}

export default OrderCardBodySummaryLabel
